import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Lang } from '../../../lib/assets';
export function LanguageScreen({
  lang,
  onSelect,
  onContinue
}: {
  lang: Lang;
  onSelect: (lang: Lang) => void;
  onContinue: () => void;
}) {
  return <section className="flex h-full flex-col px-4 pb-3 pt-5 text-white" data-id="element-67" data-mp="1f8v3yoze6di2">
      <div className="mx-auto flex h-48 w-48 items-center justify-center rounded-full border-[10px] border-[#4b8399]/65 bg-[#2785a8]/45 shadow-inner" data-id="element-68" data-mp="1b7rnc09isdfs">
        <div className="relative text-center" aria-hidden="true" data-id="element-69" data-mp="167deig03gzgp">
          <span className="text-7xl" data-id="element-70" data-mp="11923w31z6kxf">🌍</span>
          <span className="absolute -left-7 top-2 -rotate-12 rounded-full bg-[#7cc4dd] px-2 py-1 text-[9px] font-bold" data-id="element-71" data-mp="wbk16uejx1xv">Hola</span>
          <span className="absolute -right-7 top-0 rotate-12 rounded-full bg-[#ff7693] px-2 py-1 text-[9px] font-bold" data-id="element-72" data-mp="saqcvzx75l4g">Hello</span>
          <span className="absolute -right-8 bottom-2 rotate-12 rounded-full bg-[#f2ae38] px-2 py-1 text-[9px] font-bold" data-id="element-73" data-mp="2qos479cokjul">नमस्ते</span>
        </div>
      </div>
      <div className="mt-6" data-id="element-74" data-mp="yhadm7xtrpru">
        <label className="sr-only" htmlFor="language" data-id="element-75" data-mp="yfyyxd2ucxly">Language</label>
        <div className="relative" data-id="element-76" data-mp="13gwquhdnl60n">
          <select id="language" value={lang} onChange={event => onSelect(event.target.value as Lang)} className="h-11 w-full appearance-none rounded-md border border-white/10 bg-[#51455f]/90 px-3 text-sm font-bold text-white outline-none focus:ring-2 focus:ring-white/70" data-id="element-77" data-mp="13hy32p6enyjy">
            <option value="en" data-id="element-78" data-mp="1h92w38f9pslb">English</option>
            <option value="hi" data-id="element-79" data-mp="1hadzh74swybw">हिंदी</option>
            <option value="mr" data-id="element-80" data-mp="1m630zg0dspau">मराठी</option>
          </select>
          <ChevronDown aria-hidden="true" className="pointer-events-none absolute right-3 top-3 h-4 w-4" data-id="element-81" data-mp="18fpsncjkv8kz" />
        </div>
        <p className="mt-4 text-center text-sm leading-tight" data-id="element-82" data-mp="1cgt6xulz8wk3">Select the language you want<br data-id="element-83" data-mp="206x9dynfiq9i" />to see the Rangeet app in!</p>
      </div>
      <button onClick={onContinue} className="mt-auto h-11 w-full rounded-md bg-white text-sm font-extrabold tracking-wide text-[#34313c] shadow-sm transition active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70" data-id="element-84" data-mp="205cj4l85dthg">
        NEXT
      </button>
    </section>;
}